import {createSelector} from 'reselect';
import {getSettings} from './selectors';

export const clickAndCollectVerticalButtonLayout = createSelector(
  [getSettings],
  settings => settings.click_and_collect_vertical_button_layout,
);

export const clickAndCollectHorizontalButtonLayout = createSelector(
  [getSettings],
  settings => settings.click_and_collect_horizontal_button_layout,
);

export const isClickAndCollectButtonLayout = createSelector(
  [clickAndCollectVerticalButtonLayout, clickAndCollectHorizontalButtonLayout],
  (isVerticalButtonLayout, isHorizontalButtonLayout) => isVerticalButtonLayout || isHorizontalButtonLayout,
);
